export default function Footer() {
  return (
    <footer className="py-6 text-center text-sm text-slate-500 dark:text-slate-400">
      © {new Date().getFullYear()} Suksham Gupta
    </footer>
  );
}
